import React, { useEffect, useState } from 'react'
import { useSettingCountryList } from './hooks'
import { ColumnsType } from 'antd/lib/table'
import moment from 'moment/moment'
import { CButton, CCardBody } from '@coreui/react-pro'
import { CountrySetting } from './types'
import { Table } from 'antd'
import CIcon from '@coreui/icons-react'
import { cilDelete } from '@coreui/icons'
import { CreateCountrySetting } from '../create/page'
import { ConfirmModal } from '../../../../views/widgets/confirmModal'
import { submitCreateCountrySetting } from '../create/model'
import { useUnit } from 'effector-react'
import { $countriesList } from '../../../../features/dictionaries/model'
import { transformCountriesToOptions } from '../../../../libs/formatCountries'

export const CountrySettingList: React.FC = () => {
  const [isOpenModal, setIsOpenModal] = React.useState({
    isCreate: false,
    isDelete: false,
  })
  const [currentCountry, setCurrentCountry] = React.useState<CountrySetting>()

  const {
    settingCountryList,
    onChangeSettingCountryList,
    totalCountOfSettingCountryList,
    loading,
  } = useSettingCountryList()

  const countriesList = useUnit($countriesList)

  const [orderBy, setOrderBy] = useState('')
  const [orderDirection, setOrderDirection] = useState('-')

  const handleTableChange = ({
    currentPage,
    currentPageSize,
    currentOrderBy,
    currentOrderDirection,
  }: {
    currentPage?: number
    currentPageSize?: number
    currentOrderBy?: string
    currentOrderDirection?: string
  }) => {
    if (currentOrderBy) {
      setOrderBy(currentOrderBy)
    }
    if (currentOrderDirection) {
      if (currentOrderDirection == 'descend') {
        setOrderDirection('-')
      } else {
        setOrderDirection('')
      }
    }
  }

  useEffect(() => {
    onChangeSettingCountryList({
      orderBy: orderBy,
      orderDirection: orderDirection,
    })
  }, [orderBy, orderDirection])

  const columns: ColumnsType<CountrySetting> = [
    {
      title: 'Code',
      dataIndex: 'countryCode',
    },
    {
      title: 'Name',
      render: (item: CountrySetting) => {
        return (
          transformCountriesToOptions(countriesList).find(
            (country) => country.value === item.countryCode,
          )?.text || ''
        )
      },
    },
    {
      title: 'Added',
      dataIndex: 'createdAt',
      sorter: (a, b) =>
        // @ts-ignore
        new Date(moment(a.updatedAt, 'MMMM Do YYYY, h:mm:ss a').format('LLL')) -
        // @ts-ignore
        new Date(moment(b.updatedAt, 'MMMM Do YYYY, h:mm:ss a').format('LLL')),
    },
    {
      title: 'Actions',
      fixed: 'right',
      width: 100,
      render: (item) => {
        return (
          <>
            <CButton
              color="danger"
              className="me-2"
              title="Delete"
              onClick={() => {
                setIsOpenModal((prevState) => ({
                  ...prevState,
                  isDelete: true,
                }))
                setCurrentCountry(item)
              }}
            >
              <CIcon icon={cilDelete} />
            </CButton>
          </>
        )
      },
    },
  ]

  const handleDeleteCountry = () => {
    submitCreateCountrySetting(
      settingCountryList
        .filter((item) => item.countryCode !== currentCountry?.countryCode)
        .map((item) => item.countryCode),
    )
    setIsOpenModal((prevState) => ({
      ...prevState,
      isDelete: false,
    }))
  }

  return (
    <CCardBody>
      <CButton
        color="primary"
        className="mb-2"
        onClick={() =>
          setIsOpenModal((prevState) => ({
            ...prevState,
            isCreate: true,
          }))
        }
      >
        Add country
      </CButton>
      <Table
        dataSource={settingCountryList}
        bordered={true}
        scroll={{ x: true }}
        loading={loading}
        rowKey="countrySettingID"
        columns={columns}
        pagination={{
          showSizeChanger: true,
          total: totalCountOfSettingCountryList,
        }}
        onChange={(pagination, filters, sorter, extra) =>
          handleTableChange({
            //@ts-ignore
            currentPage: pagination.current, //@ts-ignore
            currentPageSize: pagination.pageSize, //@ts-ignore
            currentOrderDirection: sorter.order, //@ts-ignore
            currentOrderBy: sorter.field,
          })
        }
      />
      <CreateCountrySetting
        isVisible={isOpenModal.isCreate}
        onClose={() =>
          setIsOpenModal((prevState) => ({
            ...prevState,
            isCreate: false,
          }))
        }
      />
      <ConfirmModal
        isOpen={isOpenModal.isDelete}
        onSubmit={handleDeleteCountry}
        onCancel={() =>
          setIsOpenModal((prevState) => ({
            ...prevState,
            isDelete: false,
          }))
        }
      />
    </CCardBody>
  )
}
